document.addEventListener('DOMContentLoaded', function () {
  // Mobile nav toggle
  var toggle = document.querySelector('[data-nav-toggle]');
  var nav = document.querySelector('.main-nav');
  if (toggle && nav) {
    toggle.addEventListener('click', function () {
      var expanded = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!expanded));
      nav.classList.toggle('is-open');
    });
  }

  // Resources: filter tabs
  var tabs = document.querySelectorAll('[data-filter-tab]');
  if (tabs.length) {
    var cards = document.querySelectorAll('[data-filter-card]');
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        tabs.forEach(function (t) { t.classList.remove('is-active'); });
        tab.classList.add('is-active');
        var filter = tab.getAttribute('data-filter-tab');
        cards.forEach(function (card) {
          var match = filter === 'all' || card.getAttribute('data-filter-card') === filter;
          card.style.display = match ? '' : 'none';
        });
      });
    });
  }

  // Audience switch tabs, when rendered as buttons rather than links (unused by default,
  // kept for editor preview safety)
});
